"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("@modules/Button"));
require("./style.scss");
const Index = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const lastPage = -1;
    const handleClickBackPage = () => navigate(lastPage);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "notFoundPage__wrapper" }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: "\u9801\u9762\u4E0D\u5B58\u5728" }), (0, jsx_runtime_1.jsx)("h3", { children: "404 Page Not Found" }), (0, jsx_runtime_1.jsx)("p", { children: "\u8ACB\u91CD\u65B0\u78BA\u8A8D\u8DEF\u5F91\uFF0C \u6216\u9EDE\u64CA\u6309\u9215\u8FD4\u56DE\u4E0A\u4E00\u9801" }), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: "primary", className: "button__back", onClick: handleClickBackPage }, { children: "\u8FD4\u56DE" }))] })));
};
exports.default = Index;
